(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kuro-fw26-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kuro-fw26-video')) {
    customElements.define('kuro-fw26-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.userPaused = false;
        this.manualPlay = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.manualPlay = true;
            this.play();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.video.addEventListener('playing', () => {
          if (!this.inView || document.hidden) { this.video.pause(); return; }
          this.classList.add('is-ready', 'is-playing');
          this.updateButton();
        }, options);
        this.video.addEventListener('pause', () => {
          this.classList.remove('is-playing');
          this.updateButton();
        }, options);
        this.video.addEventListener('error', () => {
          this.classList.remove('is-ready', 'is-playing');
          this.button.hidden = true;
        }, options);
        this.mobile.addEventListener('change', () => {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.classList.remove('is-ready', 'is-playing');
          this.button.hidden = false;
          this.sync();
        }, options);
        this.reducedMotion.addEventListener('change', () => this.sync(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: .05 });
        this.observer.observe(this);
      }

      sync() {
        const respectsPreferences = !this.reducedMotion.matches && !navigator.connection?.saveData;
        if (this.inView && !document.hidden && !this.userPaused && (respectsPreferences || this.manualPlay)) {
          this.play();
        } else {
          this.video.pause();
        }
      }

      play() {
        const src = this.mobile.matches ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc;
        if (!src) return;
        if (this.video.getAttribute('src') !== src) {
          this.video.src = src;
          this.video.load();
        }
        this.video.play().catch(() => this.updateButton());
      }

      updateButton() {
        this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
      }

      disconnectedCallback() {
        this.video?.pause();
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
